package ui

import api.repository.auth.ImplRepoAuthentication
import api.service.auth.ImplServiceAuthentication
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.w3c.dom.events.Event
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.span
import react.useState
import routes.EnumRoutes
import web.cssom.ClassName
import web.html.ButtonType

external interface AdminLoginProps: Props{

}

val AdminLogin = FC<AdminLoginProps> {
    val (email, setEmail) = useState("")
    val (password, setPassword) = useState("")
    val (showPassword, setShowPassword) = useState(false)

//    fun handleSubmit(e: Event) {
//        e.preventDefault()
////        console.log("Login attempted with:", js("({ email, password })"))
//        CoroutineScope(Dispatchers.Main).launch {
//            adminLogin(email,password)
//        }
//    }

    div {
        className = ClassName("min-h-screen bg-white flex flex-col items-center justify-center px-4 py-8")

        div {
            className = ClassName("w-full max-w-[600px] flex flex-col items-center space-y-8")

            // Header
            div {
                className = ClassName("text-center")
                h1 {
                    className = ClassName("text-2xl md:text-3xl font-normal text-brand-red mb-8 md:mb-12")
                    +"BOON CONSULTANCY ADMIN"
                }
            }

            // Logo
            div {
                className = ClassName("w-full max-w-[100px] mb-8 md:mb-12")
                img {
                    src = "https://cdn.builder.io/api/v1/image/assets/TEMP/2e32891d435eb4a54d3caeafa6a92da47ebd3323?width=762"
                    alt = "Boon Consultancy Logo"
                    className = ClassName("w-full h-auto aspect-[381/445] object-contain")
                }
            }

            // Login Form
            div {
                className = ClassName("w-full max-w-[580px] space-y-6")

                // Section Header
                div {
                    className = ClassName("bg-white shadow-lg py-3 px-4 rounded text-center")
                    h2 {
                        className = ClassName("text-lg md:text-xl font-normal text-black")
                        +"ADMIN LOGIN"
                    }
                }

                form {
                    className = ClassName("space-y-6")
//                    onSubmit = {submit->
//                        handleSubmit(submit as Event) }
//                    onSubmit = {
//                        console.log("$email $password")
//                        CoroutineScope(Dispatchers.Main).launch {
//                            adminLogin(email,password)
//                        }
//                    }

                    // Email Field
                    div {
                        className = ClassName("space-y-2")
                        label {
                            htmlFor = "email"
                            className = ClassName("block text-sm font-normal text-black")
                            +"Email"
                        }
                        div {
                            className = ClassName("relative")
                            input {
                                type = web.html.InputType.email
                                id = "email"
                                name = "email"
                                value = email
                                placeholder = "Enter your email"
                                required = true
                                className = ClassName("w-full px-4 py-3 bg-input-bg border-0 rounded-[5px] text-sm placeholder:text-placeholder focus:outline-none focus:ring-2 focus:ring-brand-red/20 pr-12")
                                onChange = { setEmail(it.target.value) }
                            }
                            div {
                                className = ClassName("absolute right-3 top-1/2 -translate-y-1/2")
                                div {
                                    className = ClassName("w-5 h-5 bg-brand-red rounded-sm flex items-center justify-center")
                                    // Placeholder for Mail icon
                                    span { className = ClassName("w-4 h-4 text-white") ; +"@" }
                                }
                            }
                        }
                    }

                    // Password Field
                    div {
                        className = ClassName("space-y-2")
                        label {
                            htmlFor = "password"
                            className = ClassName("block text-sm font-normal text-black")
                            +"Password"
                        }
                        div {
                            className = ClassName("relative")
                            input {
                                type = if (showPassword) web.html.InputType.text else web.html.InputType.password
                                id = "password"
                                name = "password"
                                value = password
                                placeholder = "Enter your password"
                                required = true
                                className = ClassName("w-full px-4 py-3 bg-input-bg border-0 rounded-[5px] text-sm placeholder:text-placeholder focus:outline-none focus:ring-2 focus:ring-brand-red/20 pr-12")
                                onChange = { setPassword(it.target.value) }
                            }
                            button {
                                type = web.html.ButtonType.button
                                className = ClassName("absolute right-3 top-1/2 -translate-y-1/2")
                                onClick = { setShowPassword(!showPassword) }
                                div {
                                    className = ClassName("w-5 h-5 bg-brand-red rounded-sm flex items-center justify-center")
                                    // Placeholder for icons
                                    span {
                                        className = ClassName("w-3 h-3 text-white")
                                        +if (showPassword) "x" else "*"
                                    }
                                }
                            }
                        }
                    }

                    // Login Button
                    div {
                        className = ClassName("pt-4")
                        button {
                            type = ButtonType.button
                            onClick = {
                                CoroutineScope(Dispatchers.Main).launch {
                                    adminLogin(email,password)
                                }
                            }
                            className = ClassName("bg-brand-red hover:bg-brand-red/90 text-white font-normal py-3 px-6 rounded-xl text-sm transition-colors duration-200")
                            +"Login"
                        }
                    }

                    // Forgot Password
                    div {
                        className = ClassName("text-center pt-2")
                        a {
                            href = "#"
                            className = ClassName("text-brand-purple text-sm font-normal hover:underline")
                            +"Forgot password?"
                        }
                    }
                }
            }
        }
    }
}

suspend fun adminLogin(email: String, password: String){
    val implServiceAuth = ImplRepoAuthentication(ImplServiceAuthentication).login(email,password)
    console.log("$implServiceAuth")
    if (implServiceAuth){
        window.location.href = EnumRoutes.Dashboard.routeID
    }
}